import React from 'react';
import Outlined from '../div/Outlined'
import {Link} from 'react-router-dom'
import './help.css'

const Help = () => {
    return (
        <div className='help'>
            <h1>How Exqui can help you</h1>
            <Outlined/>
            <div className='help-wrapper'>
                <div className='help-1'>
                <img src={require('../../assets/house.png')} alt=''/>
                    <h5>Possess a home</h5>
                    <p>With a variaty of family houses we own and by the great network we have created, we help you get a house to love to start a home.</p>
                  <Link to='/others'><button>View More</button></Link>  
                </div>
                <div className='help-1'>
                      <img src={require('../../assets/house1.png')} alt=''/>
                      <h5>We help you rent a home</h5>
                    <p>Our great network across the world has enable us to come across may individual in need of homes. We help you connect with the here in Exqui.</p>
                    <Link to='/others'><button>View More</button></Link>
                </div>
                <div className='help-1'>
                <img src={require('../../assets/house2.png')} alt=''/>
                      <h5>Connect you to the best environments</h5>
                    <p>We not only help you to get a good home or land. We bring you to an environment which will facinate you. An environment that will satisfy your comfort and provide a cool sense of security.</p>
                   <Link to='/blog'><button>View More</button></Link>  
                </div>
            </div>
        </div>
    );
}

export default Help;
